var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panelify',{attrs:{"extName":"camAssist","appName":"AEFT","src":"https://camera-manager-panel.web.app/#/","width":"450px","height":"300px","gradient":0}})}
var staticRenderFns = []

export { render, staticRenderFns }